import { ObjectField, Int32Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class NeonVibrato extends ObjectField {
    static create(construct) {
        return new NeonVibrato(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get wave() {
        return this.getField(1);
    }
    get delay() {
        return this.getField(2);
    }
    get rate() {
        return this.getField(3);
    }
    get depth() {
        return this.getField(4);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "wave",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { length: 4 }, "", 0),
            2: Float32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "delay",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "rate",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            4: Float32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "depth",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
        };
    }
}
